import ArrowRightIcon from '../svg/ArrowRightIcon';

export default function NetworkItem({ item, onClick }) {
  const { icon, name, currency, disabled } = item;

  return (
    <button
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      className={`w-full px-6 py-2 border border-[#CDD9F0] rounded-[10px] flex items-center justify-between ${
        disabled
          ? 'opacity-50 cursor-not-allowed bg-[#F5F5F5]'
          : 'cursor-pointer bg-[#FCFCFC99]'
      }`}
    >
      <div className="w-8.5 h-8.5 bg-[#092F7B] rounded-full flex items-center justify-center">
        <img src={icon} alt={name} className={`w-full h-full ${disabled ? 'grayscale' : ''}`} />
      </div>
      <div>
        <p className={`text-sm font-medium leading-[22px] ${disabled ? 'text-[#A4A7AE]' : 'text-[#414651]'}`}>
          {name}
          <span className="text-xs text-[#A4A7AE] font-normal">
            {disabled ? ' (Proximamente)' : currency ? ' (' + currency + ')' : ''}
          </span>
        </p>
      </div>
      {!disabled && <ArrowRightIcon />}
    </button>
  );
}
